import angular from 'angular';

window.talenyaMissingTranslates = {};

window.addMissingTranslation = missionTranslation => window.talenyaMissingTranslates[missionTranslation] = true;

window.getMissingTranslates = () => Object.keys(window.talenyaMissingTranslates);

export function customInterpolationService($interpolate, $translateSanitization, $localStorage, utils) {
    const $identifier = 'default';

    return {
        setLocale: () => {},
        getInterpolationIdentifier: () => $identifier,
        useSanitizeValueStrategy: (value) => {
            $translateSanitization.useStrategy(value);

            return this;
        },
        interpolate: (value, interpolationParams, context, sanitizeStrategy, translationId) => {
            let interpolatedText;
            const isNumber = utils.isNumber(value);

            interpolationParams = interpolationParams || {};
            interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

            if (isNumber) {
                interpolatedText = `${value}`;
            } else if (angular.isString(value)) {
                interpolatedText = $interpolate(value)(interpolationParams);
                interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
            } else {
                interpolatedText = '';
            }

            const isMissingTranslation = translationId === undefined && $localStorage.UILanguage && !$localStorage.UILanguage[value];

            if (isMissingTranslation && !isNumber) {
                window.addMissingTranslation(value);
            }

            return interpolatedText;
        },
    };
}

angular.module('TALENYA-FE').factory('customInterpolation', customInterpolationService);
